export function getdata() {
	var obj = {
		searchlist: [{
				prop: "likeContent",
				label: '场景模板名称',
				type: "input"
			},

		],
		searchdata: {
			likeContent: ""
		},
		pagination: {
			pageNum: 1,
			pageSize: 10,
			total: 0,
			paginationkey: 0
		},
		headData: [{
				title: "序号",
				prop: "xh",
				width: "60",
				custom: true,
			},
			{
				title: "场景模板名称",
				prop: "changjmbmc",
				width: "100",
				issort: true
			},
			{
				title: "关联模板名",
				prop: "guanlfjxx",
				width: "160",
				issort: true
			},
			{
				title: "创建人",
				prop: "chuangjr",
				width: "100",
				issort: true
			},
			{
				title: "创建时间",
				prop: "chuangjsj",
				align: "left",
				width: "160"
			},
			{
				title: "修改人",
				prop: "xiugr",
				width: "100",
				issort: true
			},
			{
				title: "修改时间",
				prop: "xiugsj",
				align: "left",
				width: "160"
			},
			{
				title: "操作",
				prop: "cz",
				width: "200",
				custom: true,
				fixed: "right"
			},
		],
		additional: [{
			key: "0",
			label: "附加信息1",
		}, {
			key: "1",
			label: "附加信息2",
		}, {
			key: "2",
			label: "附加信息3",
		}, {
			key: "3",
			label: "附加信息3",
		}, {
			key: "4",
			label: "附加信息3",
		}, {
			key: "5",
			label: "附加信息3",
		}, {
			key: "6",
			label: "附加信息3",
		}, ]
	}
	return obj
}
